import React, { useState } from 'react';
import PageTransition from '../components/ui/PageTransition';
// HeroSection import removed since it's not used
// import HeroSection from '../components/sections/HeroSection';
import FeaturesOverviewSection from '../components/sections/FeaturesOverviewSection';
import IntegrationsSection from '../components/sections/IntegrationsSection';
import LiveDemoSectionV2 from '../components/sections/LiveDemoSection-v2';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import NoCodeEditorSection from '../components/sections/NoCodeEditorSection';
import SignupFormModal from '../components/ui/SignupFormModal';

const HomePage: React.FC = () => {
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');

  const openSignupModal = (itemName: string = '') => {
    setSelectedItem(itemName);
    // Scroll to the top of the page before showing the modal
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsSignupModalOpen(true);
  };

  return (
    <>
      <PageTransition>
        <LiveDemoSectionV2 />
        <FeaturesOverviewSection />
        <NoCodeEditorSection />
        <IntegrationsSection openSignupModal={openSignupModal} />
        <TestimonialsSection openSignupModal={openSignupModal} />
      </PageTransition>
      
      {/* Signup Modal - Positioned at root level */}
      <SignupFormModal 
        isOpen={isSignupModalOpen} 
        onClose={() => setIsSignupModalOpen(false)} 
      />
    </>
  );
};

export default HomePage;